import { Icon } from "@iconify/react";
import { useNavigate } from "react-router";
import { signOut } from "firebase/auth";
import { auth } from "../Firebase/Config";
import { useEffect, useState } from "react";
import { addDoc, collection, getDocs, onSnapshot } from "firebase/firestore";
import { db } from "../Firebase/Config";
import RouteWithTitle from "../Layout/RouteWithTitle";

function Admin({ children }) {
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  const logOut = (event) => {
    event.preventDefault();
    signOut(auth)
      .then(() => {
        navigate("/login");
      })
      .catch((error) => {
        setError(error);
      });
  };

  const Home = (event) => {
    event.preventDefault();
    navigate("/");
  };

  const handelShowService = (event) => {
    event.preventDefault();
    navigate("/admin/create/service");
  };

  const handelShowProject = (event) => {
    event.preventDefault();
    navigate("/admin/create/project");
  };

  const handelShowAbout = (event) => {
    event.preventDefault();
    navigate("/admin/create/about");
  };

  const handelShowMessage = (event) => {
    event.preventDefault();
    navigate("/admin/message");
  };

  return (
    <RouteWithTitle>
      <div className="flex" dir="rtl">
        <div className="w-1/6">
          <div className="h-screen bg-neutral-600">
            <ul className="cursor-pointer">
              <li className="p-3 text-white">
                <p onClick={handelShowService}>خدمات</p>
              </li>
              <li className="p-3 text-white">
                <p onClick={handelShowProject}>آخرین پروژه ها</p>
              </li>
              <li className="p-3 text-white">
                <p onClick={handelShowAbout}>درباره من</p>
              </li>
              <li className="p-3 text-white">
                <p onClick={handelShowMessage}>پیام ها</p>
              </li>
            </ul>
            <div
              className="text-white cursor-pointer flex flex-col items-center pb-2"
              onClick={Home}
            >
              <Icon
                icon="radix-icons:exit"
                wirth="40"
                height="40"
                className="cursor-pointer"
              />
              <p>صفحه اصلی</p>
            </div>
            <div
              className="text-white cursor-pointer flex flex-col items-center"
              onClick={logOut}
            >
              <Icon
                icon="radix-icons:exit"
                wirth="40"
                height="40"
                className="cursor-pointer"
              />
              <p>خروج</p>
            </div>
            {error ? <p className="text-white">{error}</p> : ""}
          </div>
        </div>
        <main className="w-full h-screen flex flex-col gap-y-3 bg-stone-500">
          {children}
        </main>
      </div>
    </RouteWithTitle>
  );
}

export default Admin;




const collectionNames = { services: "service", projects: "project", about: "about", messages: "contect" };
const sections = [
  { id: "overview", label: "نمای کلی", icon: "home" },
  { id: "services", label: "خدمات", icon: "services" },
  { id: "projects", label: "پروژه‌ها", icon: "projects" },
  { id: "about", label: "مهارت‌ها", icon: "skills" },
  { id: "messages", label: "پیام‌ها", icon: "messages" },
];
const addFields = {
  services: [
    { name: "Title", label: "عنوان خدمت", placeholder: "مثلاً طراحی وب‌سایت" },
    { name: "Description", label: "توضیحات", placeholder: "توضیح کوتاهی دربارهٔ خدمت بنویس", multiline: true },
    { name: "Picture", label: "تصویر خدمت", type: "file", accept: "image/*" },
  ],
  projects: [
    { name: "Title", label: "عنوان پروژه", placeholder: "نام پروژه را وارد کن" },
    { name: "Description", label: "توضیحات", placeholder: "دربارهٔ پروژه بنویس", multiline: true },
    { name: "Href", label: "پیوند پروژه", placeholder: "https://example.com", type: "url" },
  ],
  about: [
    { name: "Title", label: "عنوان مهارت", placeholder: "مثلاً طراحی رابط کاربری" },
    { name: "Size", label: "میزان تسلط", placeholder: "از ۰ تا ۱۰۰", type: "number" },
  ],
};

function SectionIcon({ name, className = "" }) {
  const paths = {
    home: <><path d="m3 10 9-7 9 7"/><path d="M5 9v11h14V9M9 20v-6h6v6"/></>,
    services: <><rect x="3" y="7" width="18" height="13" rx="2"/><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 12h18m-11 0v2h4v-2"/></>,
    projects: <><path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z"/></>,
    skills: <><path d="m12 3 2.2 5.8L20 11l-5.8 2.2L12 19l-2.2-5.8L4 11l5.8-2.2L12 3Z"/><path d="m19 14 1.2 2.8L23 18l-2.8 1.2L19 22l-1.2-2.8L15 18l2.8-1.2L19 14Z"/></>,
    messages: <><rect x="3" y="4" width="18" height="15" rx="2"/><path d="m4 6 8 6 8-6M8 22l4-3 4 3"/></>,
  };
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{paths[name]}</svg>;
}

const readImageAsDataUrl = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result);
  reader.onerror = () => reject(new Error("خواندن تصویر انتخاب‌شده ممکن نشد."));
  reader.readAsDataURL(file);
});

function AdminDashboard() {
  const [active, setActive] = useState("overview");
  const [showAddModal, setShowAddModal] = useState(false);
  const [draft, setDraft] = useState({});
  const [selectedFileName, setSelectedFileName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [saveError, setSaveError] = useState("");
  const [search, setSearch] = useState("");
  const [records, setRecords] = useState({ services: [], projects: [], about: [], messages: [] });
  const [errors, setErrors] = useState({});
  const [loaded, setLoaded] = useState({});
  const activeSection = sections.find((item) => item.id === active);
  const activeAddFields = addFields[active];

  const openAddModal = () => {
    setDraft({});
    setSelectedFileName("");
    setSelectedFile(null);
    setSaveError("");
    setShowAddModal(true);
  };

  const saveNewItem = async (event) => {
    event.preventDefault();
    if (!activeAddFields || !draft.Title?.trim() || isSaving) return;
    setIsSaving(true);
    setSaveError("");
    try {
      const ref = collection(db, collectionNames[active]);
      const snapshot = await getDocs(ref);
      const nextId = snapshot.docs.reduce((maxId, entry) => Math.max(maxId, Number(entry.data().Id) || 0), 0) + 1;
      const item = { Id: nextId, Title: draft.Title.trim() };
      if (active === "services") {
        item.Description = (draft.Description || "").trim();
        item.Picture = selectedFile ? await readImageAsDataUrl(selectedFile) : "";
      } else if (active === "projects") {
        item.Description = (draft.Description || "").trim();
        item.Href = (draft.Href || "").trim();
      } else {
        item.Size = draft.Size || "";
      }
      const created = await addDoc(ref, item);
      setRecords((current) => ({ ...current, [active]: [...current[active], { id: created.id, ...item }] }));
      setLoaded((current) => ({ ...current, [active]: true }));
      setShowAddModal(false);
    } catch (error) {
      console.error("Saving new admin item failed:", error);
      setSaveError("ذخیره انجام نشد. اتصال و دسترسی پایگاه داده را بررسی کن و دوباره تلاش کن.");
    } finally {
      setIsSaving(false);
    }
  };
  useEffect(() => {
    const unsubscribers = Object.entries(collectionNames).map(([key, collectionName]) => onSnapshot(
      collection(db, collectionName),
      (snapshot) => {
        const nextRecords = snapshot.docs.map((entry) => ({ id: entry.id, ...entry.data() })).sort((a, b) => Number(a.Id || 0) - Number(b.Id || 0));
        setRecords((current) => ({ ...current, [key]: nextRecords }));
        setErrors((current) => ({ ...current, [key]: false }));
        setLoaded((current) => ({ ...current, [key]: true }));
      },
      () => {
        setErrors((current) => ({ ...current, [key]: true }));
        setLoaded((current) => ({ ...current, [key]: true }));
      }
    ));
    return () => unsubscribers.forEach((unsubscribe) => unsubscribe());
  }, []);

  const getTitle = (item, key) => key === "messages" ? (item.FirstAndLastname || "پیام بدون نام") : (item.Title || "بدون عنوان");
  const getSubtitle = (item, key) => {
    if (key === "services") return item.Description || "بدون توضیح";
    if (key === "projects") return [item.Description, item.Href].filter(Boolean).join(" · ") || "بدون توضیح";
    if (key === "about") return item.Size ? `سطح مهارت: ${item.Size}%` : "مهارت";
    return [item.Email, item.Subject, item.Message].filter(Boolean).join(" · ") || "پیام";
  };

  const renderList = (key) => {
    const filtered = records[key].filter((item) => `${getTitle(item, key)} ${getSubtitle(item, key)}`.toLowerCase().includes(search.toLowerCase()));
    if (loaded[key] && errors[key]) return <div className="admin-dashboard-empty">دسترسی به این بخش از سرور ممکن نشد.</div>;
    if (!loaded[key]) return <div className="admin-dashboard-empty">در حال دریافت اطلاعات از سرور…</div>;
    if (!filtered.length) return <div className="admin-dashboard-empty">برای این بخش هنوز موردی در سرور ثبت نشده است.</div>;
    return <div className="admin-dashboard-list">{filtered.map((item, index) => <article className="admin-dashboard-row" key={item.id}>
      <span className="admin-dashboard-row-num">{String(item.Id || index + 1).padStart(2, "0")}</span>
      <div className="admin-dashboard-row-main"><b>{getTitle(item, key)}</b><small>{getSubtitle(item, key)}</small></div>
      <span className="admin-dashboard-status">سرور</span>
    </article>)}</div>;
  };

  return (
    <div className="admin-dashboard-shell" dir="rtl">
      <aside className="admin-dashboard-sidebar">
        <a className="admin-dashboard-brand" href="/"><span className="admin-dashboard-brand-mark"><img src="/fav.png" alt="" /></span><span><b>امیرحسین سیفی</b></span></a>
        <div className="admin-dashboard-menu-label">مدیریت محتوا</div>
        <nav className="admin-dashboard-nav" aria-label="بخش‌های پنل">
          {sections.map((item) => <button className={active === item.id ? "active" : ""} key={item.id} type="button" onClick={() => { setActive(item.id); setSearch(""); }}><SectionIcon name={item.icon} />{item.label}{item.id === "messages" && records.messages.length > 0 && <i>{records.messages.length}</i>}</button>)}
        </nav>
        <div className="admin-dashboard-sidebar-spacer" />
        <a className="admin-dashboard-back" href="/"><span>↗</span> مشاهدهٔ وب‌سایت</a>
      </aside>

      <main className="admin-dashboard-main">
        <header className="admin-dashboard-topbar">
          <div><span className="admin-dashboard-breadcrumb">پنل /</span><b>{activeSection.label}</b></div>
          <div className="admin-dashboard-profile"><span className="admin-dashboard-avatar">ا</span><span><b>امیرحسین سیفی</b><small>مدیر وب‌سایت</small></span><span className="admin-dashboard-chevron">⌄</span></div>
        </header>
        <div className="admin-dashboard-content" key={active}>
          {Object.values(errors).some(Boolean) && <div className="admin-dashboard-error">برای بعضی بخش‌ها دسترسی از سرور دریافت نشد.</div>}
          <div className="admin-dashboard-page-heading"><div><span className="admin-dashboard-kicker">مدیریت وب‌سایت</span><h1>{active === "overview" ? "خوش آمدی، امیرحسین" : activeSection.label}</h1><p>{active === "overview" ? "وضعیت کلی محتوا و میان‌برهای پنل را اینجا ببین." : `اطلاعات زندهٔ بخش ${activeSection.label} از سرور.`}</p></div>{activeAddFields && <button className="admin-dashboard-add-button" type="button" onClick={openAddModal}><span>＋</span> افزودن {active === "services" ? "خدمت" : active === "projects" ? "پروژه" : "مهارت"}</button>}</div>

          {active === "overview" ? <>
            <div className="admin-dashboard-stats">
              <article><SectionIcon name="services" className="admin-dashboard-stat-icon olive"/><small>خدمات</small><b>{loaded.services ? records.services.length : "—"}</b><em>دریافت‌شده از سرور</em></article>
              <article><SectionIcon name="projects" className="admin-dashboard-stat-icon blue"/><small>پروژه‌ها</small><b>{loaded.projects ? records.projects.length : "—"}</b><em>دریافت‌شده از سرور</em></article>
              <article><SectionIcon name="skills" className="admin-dashboard-stat-icon peach"/><small>مهارت‌ها</small><b>{loaded.about ? records.about.length : "—"}</b><em>دریافت‌شده از سرور</em></article>
              <article><SectionIcon name="messages" className="admin-dashboard-stat-icon lavender"/><small>پیام‌ها</small><b>{loaded.messages ? records.messages.length : "—"}</b><em>دریافت‌شده از سرور</em></article>
            </div>
            <div className="admin-dashboard-panels">
              <section className="admin-dashboard-panel admin-dashboard-panel-wide"><div className="admin-dashboard-panel-heading"><div><h2>محتوای سایت</h2><p>مرور سریع داده‌های زنده</p></div><button type="button" onClick={() => setActive("services")}>دیدن همه <span>←</span></button></div>
                <div className="admin-dashboard-quick-grid">{sections.slice(1, 4).map((item, index) => <button type="button" key={item.id} onClick={() => setActive(item.id)}><SectionIcon name={item.icon} className={`admin-dashboard-quick-icon quick-${index}`}/><b>{item.label}</b><small>{loaded[item.id] ? `${records[item.id].length} مورد` : "در حال دریافت…"}</small><span className="admin-dashboard-quick-arrow">↙</span></button>)}</div>
              </section>
              <section className="admin-dashboard-panel"><div className="admin-dashboard-panel-heading"><div><h2>آخرین پروژه‌ها</h2><p>از مجموعهٔ سرور</p></div><button type="button" onClick={() => setActive("projects")}>همه <span>←</span></button></div>{records.projects.slice(0, 3).map((item, i) => <div className="admin-dashboard-mini-row" key={item.id}><span className={`admin-dashboard-mini-thumb mini-${i}`}>{String(item.Id || i + 1).padStart(2, "0")}</span><span><b>{item.Title || "بدون عنوان"}</b><small>پروژه</small></span><i>↗</i></div>)}{loaded.projects && !records.projects.length && <div className="admin-dashboard-empty">هنوز پروژه‌ای ثبت نشده است.</div>}</section>
            </div>
          </> : <section className="admin-dashboard-panel admin-dashboard-full-panel"><div className="admin-dashboard-panel-heading"><div><h2>{activeSection.label}</h2><p>{active === "messages" ? "پیام‌های ثبت‌شده در سرور؛ این فهرست فقط برای مشاهده است." : "فهرست زنده از سرور؛ تغییری در داده‌ها ذخیره نمی‌شود."}</p></div><label className="admin-dashboard-search"><span>⌕</span><input value={search} onChange={(event) => setSearch(event.target.value)} placeholder="جست‌وجو در فهرست" /></label></div>{renderList(active)}</section>}
          {showAddModal && activeAddFields && <div className="admin-dashboard-modal-backdrop" onMouseDown={(event) => { if (event.target === event.currentTarget && !isSaving) setShowAddModal(false); }}><section className="admin-dashboard-add-modal" role="dialog" aria-modal="true" aria-labelledby="admin-dashboard-modal-title"><div className="admin-dashboard-modal-heading"><div><span className="admin-dashboard-kicker">محتوای تازه</span><h2 id="admin-dashboard-modal-title">افزودن {active === "services" ? "خدمت" : active === "projects" ? "پروژه" : "مهارت"}</h2></div><button type="button" aria-label="بستن پنجره" onClick={() => !isSaving && setShowAddModal(false)}>×</button></div><form onSubmit={saveNewItem}><div className="admin-dashboard-modal-fields">{activeAddFields.map((field) => <label className={field.multiline ? "wide" : ""} key={field.name}><span>{field.label}</span>{field.type === "file" ? <span className="admin-dashboard-file-picker"><span className="admin-dashboard-file-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="8.5" cy="9" r="1.5"/><path d="m21 15-5-5L5 20"/></svg></span><span className="admin-dashboard-file-copy"><b>{selectedFileName || "انتخاب تصویر"}</b><small>{selectedFileName ? "تصویر انتخاب شد" : "PNG، JPG یا WEBP"}</small></span><span className="admin-dashboard-file-action">انتخاب فایل</span><input className="admin-dashboard-file-input" type="file" accept={field.accept} aria-label="انتخاب تصویر خدمت" onChange={(event) => { const file = event.target.files?.[0] || null; setSelectedFile(file); setSelectedFileName(file?.name || ""); }}/></span> : field.multiline ? <textarea rows="4" placeholder={field.placeholder} value={draft[field.name] || ""} onChange={(event) => setDraft((current) => ({ ...current, [field.name]: event.target.value }))}/> : <input type={field.type || "text"} placeholder={field.placeholder} value={draft[field.name] || ""} onChange={(event) => setDraft((current) => ({ ...current, [field.name]: event.target.value }))}/>}</label>)}</div>{saveError && <p className="admin-dashboard-save-error" role="alert">{saveError}</p>}<div className="admin-dashboard-modal-actions"><button className="admin-dashboard-modal-cancel" type="button" disabled={isSaving} onClick={() => setShowAddModal(false)}>بستن</button><button className="admin-dashboard-modal-save" type="submit" disabled={isSaving || !draft.Title?.trim()}>{isSaving ? "در حال ذخیره…" : "ذخیره"}</button></div></form></section></div>}
        </div>
      </main>
    </div>
  );
}


export { AdminDashboard };
